(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (c) => (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c) : '$' + (c / 100).toFixed(2);

  /* ---------- reveals ---------- */
  let io;
  const initReveals = () => {
    if (io) io.disconnect();
    if (reduce || !('IntersectionObserver' in window)) { $$('.ah-reveal').forEach((el) => el.classList.add('ah-in')); return; }
    io = new IntersectionObserver((es) => {
      es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('ah-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    $$('.ah-reveal:not(.ah-in)').forEach((el) => {
      const sibs = [...el.parentElement.children].filter((c) => c.classList.contains('ah-reveal'));
      if (!el.closest('.ah-hero')) el.style.setProperty('--ah-d', `${Math.min(sibs.indexOf(el), 7) * 0.07}s`);
      io.observe(el);
    });
    requestAnimationFrame(() => $$('.ah-hero .ah-reveal').forEach((el) => el.classList.add('ah-in')));
    // Theme editor: never leave content hidden
    if (window.Shopify && Shopify.designMode) $$('.ah-reveal').forEach((el) => el.classList.add('ah-in'));
  };

  /* ---------- scroll-driven bits ---------- */
  const pinned = () => matchMedia('(min-width: 981px)').matches;
  const onScroll = () => {
    const hdr = $('.ah-hdr');
    if (hdr) hdr.classList.toggle('ah-is-scrolled', scrollY > 40);
    if (!reduce) $$('[data-ah-parallax]').forEach((el) => {
      const r = el.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      const k = parseFloat(el.dataset.ahParallax);
      const off = el.closest('.ah-hero') ? r.top : (r.top + r.height / 2 - innerHeight / 2);
      el.style.transform = `translate3d(0,${(off * -k).toFixed(1)}px,0)`;
    });
    $$('[data-ah-system]').forEach((track) => {
      if (!pinned()) return;
      const r = track.getBoundingClientRect();
      const total = r.height - innerHeight;
      const p = Math.min(1, Math.max(0, -r.top / total));
      const steps = $$('.ah-step', track);
      const bar = $('[data-ah-progress]', track);
      if (bar) bar.style.width = `${(p * 100).toFixed(2)}%`;
      setStep(track, Math.min(steps.length - 1, Math.floor(p * steps.length)));
    });
  };
  const setStep = (track, i) => {
    if (track._step === i) return;
    track._step = i;
    $$('.ah-step', track).forEach((s, n) => s.classList.toggle('ah-is-active', n === i));
    $$('[data-ah-step-img]', track).forEach((m, n) => m.classList.toggle('ah-is-active', n === i));
    const c = $('[data-ah-counter]', track);
    if (c) c.textContent = String(i + 1).padStart(2, '0');
  };
  const initSystem = () => {
    $$('[data-ah-system]').forEach((track) => {
      const steps = $$('.ah-step', track);
      track.style.height = pinned() ? `${Math.max(2, steps.length) * 100}vh` : '';
      steps.forEach((s, i) => {
        s.onclick = (e) => {
          if (e.target.closest('a') || !pinned()) return;
          const r = track.getBoundingClientRect();
          const total = r.height - innerHeight;
          scrollTo({ top: scrollY + r.top + total * ((i + 0.5) / steps.length), behavior: reduce ? 'auto' : 'smooth' });
        };
      });
      if (!pinned()) setStep(track, 0);
      clearInterval(track._timer);
      if (!reduce) track._timer = setInterval(() => {
        if (pinned()) return;
        const n = $$('[data-ah-step-img]', track).length;
        setStep(track, ((track._step || 0) + 1) % n);
      }, 3200);
    });
  };

  let ticking = false;
  addEventListener('scroll', () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => { onScroll(); ticking = false; });
  }, { passive: true });
  addEventListener('resize', () => { initSystem(); onScroll(); });

  /* ---------- drawer ---------- */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-ah-open-menu]');
    const drawer = $('[data-ah-menu]');
    if (!drawer) return;
    if (open) { drawer.hidden = false; document.body.style.overflow = 'hidden'; return; }
    if (!drawer.hidden && (e.target.closest('[data-ah-close-menu]') || e.target === drawer || e.target.closest('.ah-drawer a'))) {
      drawer.hidden = true; document.body.style.overflow = '';
    }
  });

  /* ---------- cart (real Shopify AJAX cart) ---------- */
  const toast = (html) => {
    const t = $('.ah-toast'); if (!t) return;
    t.innerHTML = html; t.classList.add('ah-show');
    clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('ah-show'), 3200);
  };
  const setCount = (n) => $$('.ah-bag__count').forEach((c) => {
    c.textContent = n; c.classList.add('ah-bump'); setTimeout(() => c.classList.remove('ah-bump'), 300);
  });
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ah-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button'); if (btn) btn.disabled = true;
    try {
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
      const cart = await (await fetch(root + 'cart.js')).json();
      setCount(cart.item_count);
      toast(`Added: ${data.product_title || data.title} <a href="${root}cart">View bag</a>`);
      document.dispatchEvent(new CustomEvent('ah:cart:added', { detail: data }));
    } catch (err) {
      toast(err.message);
    } finally { if (btn) btn.disabled = false; }
  });

  const init = () => { initReveals(); initSystem(); onScroll(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', (e) => {
    const step = e.target.closest && e.target.closest('.ah-step');
    if (step) { const track = step.closest('[data-ah-system]'); setStep(track, $$('.ah-step', track).indexOf(step)); }
  });
})();
